export { default } from './Icon';
export { NamedIcon } from './NamedIcon';
export { default as SvgIcon } from './SvgIcon';
export { getLocalSvgIconString, getLocalSvgIcon, isPurpurIconName } from './utils';
